// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3295":"css/app.6635","9982":"css/admin-app.6635"}[chunkId] + ".css";
};